import { createContext, useContext } from 'react';

/**
 * Id of the public-API instance the tree belongs to (`Configento.instances`),
 * for views that hand the instance to host code — custom renderers. Undefined
 * in tests and previews without a registered instance.
 */
export const InstanceIdContext = createContext<string | undefined>(undefined);

export function useInstanceId(): string | undefined {
    return useContext(InstanceIdContext);
}
